import CareersPage from 'screens/Careers/Careers';

export default CareersPage;
